<template>
	<div class="info-cards">
		<article
			v-for="(card, cardId) in cards"
			:key="cardId"
			class="info-card gap-300-lg gap-150-md display-flex-md align-items-center-md pb-600"
		>
			<div
				v-reveal:fade-up
				role="figure"
				:class="[
					evenColumns ? 'col-6-md' : 'col-7-md',
					'pl-100-smo pr-100-smo mb-150-smo',
					{ 'order-1': getAlignment(cardId) }
				]"
			>
				<picture v-if="card.fallbackImageUrl">
					<source :srcset="useFullImgUrl ? card.imageUrl : appCloudfrontPath + card.imageUrl" />
					<img
						:src="useFullImgUrl ? card.fallbackImageUrl : appCloudfrontPath + card.fallbackImageUrl"
						:alt="card.imageAlt"
					/>
				</picture>
				<img
					v-else
					:src="useFullImgUrl ? card.imageUrl : appCloudfrontPath + card.imageUrl"
					:alt="card.imageAlt"
				/>
				<figure v-if="card.imageCaption" class="eta mt-50 display-none-smo" style="width: 45%">
					<p class="tooltip-heading body-text-color">
						{{ card.imageCaptionHeading || 'Did you know?' }}
					</p>
					<p class="tooltip-body" v-html="card.imageCaption"></p>
				</figure>
			</div>
			<div :class="evenColumns ? 'col-6-md' : 'col-5-md'">
				<div v-if="card.heading" class="overline mb-100">
					{{ card.heading }}
				</div>
				<h3 :class="cardHeadingStyle">
					{{ card.title }}
				</h3>
				<p v-for="(desc, descId) in card.description" :key="descId" v-html="desc"></p>
				<p v-if="card.link" class="mt-100">
					<BaseCtaLink :link="card.link" icon="arrow" />
				</p>
				<p
					v-for="note in card.footnotes"
					:key="note"
					:class="'footnote body-xs text-color-content-tertiary mt-300'"
					v-html="note"
				></p>
			</div>
		</article>
	</div>
</template>

<script setup lang="ts">
import { appCloudfrontPath } from '@constants';
import { InfoCard } from 'types/layout';

interface Props {
	cards: Array<InfoCard>;
	swapOrder?: boolean;
	cardHeadingStyle?: string;
	evenColumns?: boolean;
	useFullImgUrl?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
	swapOrder: false,
	cardHeadingStyle: 'heading-1',
	evenColumns: true,
	useFullImgUrl: false
});

function getAlignment(index: number): boolean {
	return props.swapOrder ? isEven(index) : isOdd(index);
}

function isEven(index: number): boolean {
	return index % 2 === 0;
}

function isOdd(index: number): boolean {
	return index % 2 === 1;
}
</script>
